import React from 'react';
import '../Style/Saasbenefits.css';

const icons = {
  ux: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="3" y="4" width="18" height="14" rx="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 9h18" strokeLinecap="round" />
      <path d="M9 21h6M12 18v3" strokeLinecap="round" />
    </svg>
  ),
  scalability: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5M3 3l6 6M21 3l-6 6M3 21l6-6M21 21l-6-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  deployment: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M7 17a4 4 0 0 1-1-7.9A5 5 0 0 1 15.5 8 4.5 4.5 0 0 1 17 17H7Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 12v6M9.5 15.5 12 18l2.5-2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  business: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 13.5a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.9 2.9l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.9-2.9l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.6-1H4a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9l-.1-.1a2 2 0 1 1 2.9-2.9l.1.1a1.7 1.7 0 0 0 1.9.3H10a1.7 1.7 0 0 0 1-1.6V4a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.9 2.9l-.1.1a1.7 1.7 0 0 0-.3 1.9V10a1.7 1.7 0 0 0 1.6 1H20a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.6 1Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  security: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 3 4.5 6v6c0 4.5 3 7.5 7.5 9 4.5-1.5 7.5-4.5 7.5-9V6L12 3Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="m9 12 2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

const benefits = [
  {
    id: 1,
    icon: 'ux',
    title: 'Improved User Experience',
    description: 'We create intuitive SaaS applications with clean interfaces, responsive design, and seamless navigation that enhance customer engagement and increase user satisfaction.',
  },
  {
    id: 2,
    icon: 'scalability',
    title: 'Scalability & Flexibility',
    description: 'Our cloud-native SaaS platforms are designed to grow alongside your business, allowing new features, users, and integrations without compromising performance.',
  },
  {
    id: 3,
    icon: 'deployment',
    title: 'Easy Deployment & Updates',
    description: 'Cloud-based SaaS applications enable centralized deployment, automatic updates, and simplified maintenance, ensuring users always access the latest features.',
  },
  {
    id: 4,
    icon: 'business',
    title: 'Enhanced Business Operations',
    description: 'Automate repetitive tasks, improve team collaboration, streamline business processes, and increase productivity with customized SaaS solutions built for efficiency.',
  },
  {
    id: 5,
    icon: 'security',
    title: 'Enterprise-Grade Security',
    description: 'Protect sensitive business information with advanced authentication, encrypted databases, secure APIs, regular security updates, and compliance-focused SaaS architecture.',
  },
];

const SaasBenefits = () => {
  return (
    <section className="saasbenefits-section">
      <div className="saasbenefits-inner">
        <h2 className="saasbenefits-heading">
          Why Custom SaaS Solutions Drive Business Growth
        </h2>

        {/* Row 1 — 3 cards */}
        <div className="saasbenefits-row">
          {benefits.slice(0, 3).map((item) => (
            <div className="saasbenefits-card" key={item.id}>
              <div className="saasbenefits-card__icon-wrap">{icons[item.icon]}</div>

              <h3 className="saasbenefits-card__title">
                {item.title}
              </h3>

              <p className="saasbenefits-card__desc">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Row 2 — 2 cards */}
        <div className="saasbenefits-row saasbenefits-row--2">
          {benefits.slice(3, 5).map((item) => (
            <div className="saasbenefits-card" key={item.id}>
              <div className="saasbenefits-card__icon-wrap">{icons[item.icon]}</div>

              {item.title && (
                <h3 className="saasbenefits-card__title">
                  {item.title}
                </h3>
              )}

              {item.description && (
                <p className="saasbenefits-card__desc">
                  {item.description}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SaasBenefits;